import React, { createContext, useContext, useRef } from 'react';
import { MarketContextManager, MarketToaster } from '@market/react';

const MarketContext = createContext({
  context: null,
  toaster: null,
});

/*
  Custom hook to extract refs to the
  market-context-manager and market-toaster

  Usage:
    const market = useMarketManagers();
    market.toaster.current.show(myToast.current);
    market.contextManager.current.open(myModal.current);
 */
const useMarketManagers = () => {
  return useContext(MarketContext);
};

/*
  Provides a component that wraps your app with
  market-context-manager and market-toaster for
  easier usage of market-toast, market-modal, etc.
 */
const MarketManagers = (props) => {
  const context = useRef(null);
  const toaster = useRef(null);

  const values = { context, toaster };

  return (
    <MarketContext.Provider value={values}>
      <MarketContextManager ref={context} />
      <MarketToaster ref={toaster} />
      {props.children}
    </MarketContext.Provider>
  );
};

export { MarketManagers, useMarketManagers };
